"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.931 2.383c1.091 0 1.988.85 2.064 1.921l.005.148v15.096c0 1.09-.85 1.988-1.921 2.064l-.148.005H2.07a2.072 2.072 0 0 1-2.065-1.922L0 19.549V4.452c0-1.09.85-1.988 1.922-2.064l.148-.005h19.86Zm-5.495 7.845a1.556 1.556 0 0 0-1.107.396l-.107.108-4.036 4.507a.48.48 0 0 1-.636.07l-.061-.051-2.034-2.034a1.526 1.526 0 0 0-1.948-.173l-.118.09L.96 17.756v1.792c0 .57.433 1.042.989 1.102l.12.007h19.862a1.11 1.11 0 0 0 1.102-.988l.007-.121v-1.297l-5.455-7.406a1.524 1.524 0 0 0-1.149-.617Zm5.495-6.885H2.07a1.11 1.11 0 0 0-1.103.988l-.007.121v12.043l4.81-4.088a2.483 2.483 0 0 1 3.226.011l.136.125 1.678 1.677 3.698-4.13a2.464 2.464 0 0 1 1.977-.82 2.467 2.467 0 0 1 1.757.86l.115.146 4.683 6.357V4.452a1.11 1.11 0 0 0-.988-1.102l-.12-.007ZM5.373 6.167A2.07 2.07 0 0 1 8.3 9.093a2.063 2.063 0 0 1-1.463.605c-.53 0-1.06-.201-1.463-.605a2.072 2.072 0 0 1 0-2.926Zm1.463.355c-.284 0-.568.108-.784.324a1.111 1.111 0 0 0 0 1.569 1.111 1.111 0 0 0 1.568 0 1.111 1.111 0 0 0 0-1.569 1.106 1.106 0 0 0-.784-.324Z",
    clipRule: "evenodd"
  })]
});